import styled from 'styled-components';

export const CSSWidgetLayer = styled.div<{ opacity: number; backgroundColor: string; pointerEvents: string }>`
    position: absolute;
    inset: 0;
    opacity: ${(props) => props.opacity};
    background-color: ${(props) => props.backgroundColor};
    pointer-events: ${(props) => props.pointerEvents};
`;
